import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { TranslationKeysMapper } from '@nimbus-library/features/localization/models/translation-keys.model';

// noinspection JSUnusedGlobalSymbols
export enum GraphApiPermissionError {
  ApplicationPermissionError = 'no_graph_api_application_permission',
}

export const graphApiPermissionErrorTranslationMap: TranslationKeysMapper<GraphApiPermissionError> = {
  no_graph_api_application_permission: TranslationKeys.AdminPermissionErrorConsentNeeded,
};
